import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  ${({ containerClass }) =>
    containerClass || `
    display: flex;
    flex-direction: column;
  `}

  span {
    color: ${({ theme }) => theme.colors.auxiliary.danger};
  }

  .fill {
    border-color: ${({ theme }) => theme.colors.secondary.health_green};
  }

  .disabled {
    background-color: ${({ theme }) => theme.colors.gray.disable};
    color: ${({ theme }) => theme.colors.gray.dark};
    border-color: ${({ theme }) => theme.colors.border.gray};
    cursor: not-allowed;

    &:hover {
      border: 1px solid ${({ theme }) => theme.colors.text.disable};
    }
  }

  .error {
    border-color: ${({ theme }) => theme.colors.auxiliary.danger};
  }

  .error-alert {
    display: flex;
    align-items: center;  
    gap: 0.2rem;
    margin-top: ${({ theme }) => theme.spacing["2xs"]};
    font-size: ${({ theme }) => theme.fontSize.fontSize.fontSizeXS};
  }
`;

export const Label = styled.label`
  color: ${({ theme }) => theme.colors.gray.dark};
  font-weight: ${({ theme }) => theme.fontWeight.fontWeight.fontWeightBold};
  font-size: ${({ theme }) => theme.fontSize.fontSize.fontSizeBase};
  line-height: ${({ theme }) => theme.lineHeight.lineHeightNormal};
  margin-bottom: 0.5rem;
`;

export const InputContainer = styled.div`
  width: ${(props) => (props.width ? props.width : "100%")};
  height: 3rem;
  align-items: center;
  display: flex;
  color: ${({ theme }) => theme.colors.gray.dark};
  padding: 0 0.875rem;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.gray.dark};
  background-color: #fff;

  :has(input:focus) {
    border: 2px solid ${({ theme }) => theme.colors.green["900"]};
  }

  :has(input:read-only){
    background-color: ${({ theme }) => theme.colors.gray.disable};
    border: 1px solid ${({ theme }) => theme.colors.border.gray};
  }

  div {
    display: flex;
    gap: 0.5rem;
  }
`;

export const Input = styled.input`
  width: 100%;
  background: transparent;
  border: 0;
  padding-right: 0.5rem;
  color: ${({ theme }) => theme.colors.gray.dark};
  font-weight: ${({ theme }) => theme.fontWeight.fontWeight.fontWeightNormal};
  font-size: 1rem;
  line-height: 1.5rem;

  :focus {
    outline: 0;
  }

  &::placeholder {
    font-size: ${({ theme }) => theme.fontSize.fontSize.fontSizeBase};
    line-height: 1.5rem;
    letter-spacing: ${({ isFirstInput }) =>
    isFirstInput ? "" : "0.02rem"};
  }
`;

export const Example = styled.div`
  margin-top: ${({ theme }) => theme.spacing["2xs"]};

  .text {
    color: ${({ theme }) => theme.colors.gray.dark};
    font-size: 0.8125rem;
    font-weight: ${({ theme }) => theme.fontWeight.fontWeight.fontWeightMedium};
    font-style: italic;
    white-space: pre-line;
  }

  .subtext {
    color: ${({ theme }) => theme.colors.secondary.health_green};
  }
`;
